/** Today's date as the YYYY-MM-DD an <input type="date"> uses, in the person's own time zone. */
export function todayLocal(now: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** What is wrong with an optional phone number, or null when it is empty or looks like a real one (7 to 15 digits). */
export function phoneProblem(phone: string): string | null {
  const value = phone.trim();
  if (value === "") return null;
  if (!/^[0-9+\-().\s]+$/.test(value)) return "Use only numbers, spaces and + - ( ).";
  const digits = value.replace(/\D/g, "").length;
  return digits >= 7 && digits <= 15 ? null : "Enter a phone number with 7 to 15 digits.";
}

/** What is wrong with an optional event date (YYYY-MM-DD), or null when it is empty or today or later. */
export function eventDateProblem(date: string, today: string = todayLocal()): string | null {
  if (date === "") return null;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || Number.isNaN(Date.parse(date))) return "Enter a valid date.";
  return date < today ? "The event date can't be in the past." : null;
}
